<app-sidebar>
  <div class="platform-billing-page">
    <div class="page-nav">
      <button mat-stroked-button color="primary" type="button" class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Back to Platform Admin
      </button>
    </div>

    <div class="page-header">
      <div>
        <h1>Organization Team Billing</h1>
        <p class="subtitle" *ngIf="data">
          {{ data.organization.displayName }} ({{ data.organization.billingPaymentType }})
        </p>
      </div>
    </div>

    <div *ngIf="loading" class="loading-state">
      <mat-spinner diameter="42"></mat-spinner>
      <p>Loading billing details...</p>
    </div>

    <ng-container *ngIf="!loading && data">
      <div class="summary-cards">
        <mat-card class="summary-card">
          <div class="summary-label">Active Team Members (Current Billable)</div>
          <div class="summary-value">{{ data.summary.teamMembers }}</div>
        </mat-card>
        <mat-card class="summary-card">
          <div class="summary-label">Total Billed</div>
          <div class="summary-value">{{ formatZarFromCents(data.summary.totalBilledCents) }}</div>
        </mat-card>
        <mat-card class="summary-card">
          <div class="summary-label">Total Settled</div>
          <div class="summary-value">{{ formatZarFromCents(data.summary.totalSettledCents) }}</div>
        </mat-card>
        <mat-card class="summary-card due-card">
          <div class="summary-label">Current Due ({{ data.summary.dueStatus }})</div>
          <div class="summary-value">{{ formatZarFromCents(data.summary.totalDueCents) }}</div>
        </mat-card>
      </div>

      <mat-card class="settle-card" *ngIf="isInvoiceOrg()">
        <h2>Settle Amount</h2>
        <p class="hint">
          Default amount is full due. Enter a lower amount for partial settlement.
        </p>
        <form [formGroup]="settleForm" class="settle-form">
          <mat-form-field appearance="outline">
            <mat-label>Paid Amount (ZAR)</mat-label>
            <input matInput type="number" step="0.01" min="0.01" formControlName="amount" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Note (optional)</mat-label>
            <input matInput formControlName="note" />
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            type="button"
            class="settle-action-btn"
            (click)="settle()"
            [disabled]="settleForm.invalid || saving">
            {{ saving ? 'Saving...' : 'Settle' }}
          </button>
        </form>
      </mat-card>

      <mat-card class="settle-card" *ngIf="isCardOrg()">
        <h2>Card Collection</h2>
        <p class="hint">
          This organization uses automatic card collection. Manual settlement is disabled here.
          Use failed-payment recovery from the tenant billing owner flow.
        </p>
      </mat-card>

      <mat-card class="months-card">
        <h2>Monthly Breakdown</h2>
        <table mat-table [dataSource]="data.months" class="mat-elevation-z1 month-table">
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Month</th>
            <td mat-cell *matCellDef="let row">{{ monthLabel(row.month) }}</td>
          </ng-container>

          <ng-container matColumnDef="teamMembers">
            <th
              mat-header-cell
              *matHeaderCellDef
              matTooltip="Monthly values are captured at billing event time and can differ from current team members.">
              Active Team Members (Billed Snapshot)
            </th>
            <td mat-cell *matCellDef="let row">{{ row.teamMembers }}</td>
          </ng-container>

          <ng-container matColumnDef="chargeCount">
            <th mat-header-cell *matHeaderCellDef>Charges</th>
            <td mat-cell *matCellDef="let row">{{ row.chargeCount }}</td>
          </ng-container>

          <ng-container matColumnDef="billed">
            <th mat-header-cell *matHeaderCellDef>Billed</th>
            <td mat-cell *matCellDef="let row">{{ formatZarFromCents(row.billedCents) }}</td>
          </ng-container>

          <ng-container matColumnDef="settled">
            <th mat-header-cell *matHeaderCellDef>Settled</th>
            <td mat-cell *matCellDef="let row">{{ formatZarFromCents(row.settledCents) }}</td>
          </ng-container>

          <ng-container matColumnDef="outstanding">
            <th mat-header-cell *matHeaderCellDef>Outstanding</th>
            <td mat-cell *matCellDef="let row">{{ formatZarFromCents(row.outstandingCents) }}</td>
          </ng-container>

          <ng-container matColumnDef="dueAt">
            <th mat-header-cell *matHeaderCellDef>Due By</th>
            <td mat-cell *matCellDef="let row">{{ formatDateTime(row.dueAt) }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-pill" [ngClass]="rowStatusClass(row)">{{ row.status }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </mat-card>
    </ng-container>
  </div>
</app-sidebar>
